import React, { Component } from "react";

import {  Button, ButtonGroup, Center} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faRefresh, faPlus, faSlash } from "@fortawesome/free-solid-svg-icons";

import ConfigService from "../../../services/ConfigService.js";
import LocalStorageService from "../../../services/LocalStorageService.js";


export default class InboundQueueGridButtonStrip extends Component {
  constructor(props) {
    super(props);

    this.state = {

    };

    this.configService = new ConfigService();
    this.localStorageService = new LocalStorageService();

    this.ifNoCurrentRowThenMsg = this.ifNoCurrentRowThenMsg.bind(this);
    this.onDeleteRequest = this.onDeleteRequest.bind(this);
    this.onRefreshGridRequest = this.onRefreshGridRequest.bind(this);
    this.onMakeObservationRequest = this.onMakeObservationRequest.bind(this);
  }

  ifNoCurrentRowThenMsg() 
  {
    if (!this.props.currentRow) {
      this.props.onMsgBoxRequest("Warning", "Select an Inbound Receipt first!", '', 'warning');
      return true;
    }
    return false;
  }

  async onDeleteRequest() 
  {
    if (this.ifNoCurrentRowThenMsg()) return;
    var orgConfig = this.localStorageService.getOrgConfig(this.props.userSession.gcid);
    //var validateResponse = new OrgRuleManager(orgConfig, "void").validate(this.props.currentObservation.data.UnderInspection.InspectionDate);
    //if (validateResponse.hasError) {
    //  this.props.onMsgBoxRequest("Warning", validateResponse.messages, '', 'warning');
    //  return;
    //}
    this.props.onDeleteRequest();
  }

  async onRefreshGridRequest(e) {
    this.props.onRefreshGridRequest();
  }

  async onMakeObservationRequest()
  {
    if (this.ifNoCurrentRowThenMsg()) return;
    await this.props.onMakeObservationRequest();
  }


  render() {

    const loadingIcon = this.props.isLoading ? (
      <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
    ) : (
      ""
    );

    return (

      <Center marginTop='10px'>

        <ButtonGroup >

        <Button
            id="refreshbutton"
            variant="solid"
            onClick={(e) => this.onMakeObservationRequest(e)}
            leftIcon={<FontAwesomeIcon icon={faPlus} />}
            bg='#0095c8'
            color='white'
            fontSize={{ base: '12px', md: '14px', lg: '18px' }}
          >
            Add Observation
          </Button>

          <Button
            id="deletebutton"
            variant="solid"
            onClick={(e) => this.onDeleteRequest(e)}
            leftIcon={<FontAwesomeIcon icon={faSlash} />}
            bg='#0095c8'
            color='white'
            fontSize={{ base: '12px', md: '14px', lg: '18px' }}
          >
            Delete
          </Button>

          <Button
            id="refreshbutton"
            variant="solid"
            onClick={(e) => this.onRefreshGridRequest(e)}
            leftIcon={<FontAwesomeIcon icon={faRefresh} />}
            bg='#0095c8'
            color='white'
            fontSize={{ base: '12px', md: '14px', lg: '18px' }}
          >
            Refresh
          </Button>

        </ButtonGroup>
        <span style={{ float: "right" }}>{loadingIcon}</span>

      </Center>
    );
  }
}
